import { ReactNode, useMemo } from "react";
import {
    ChatSurfaceProvider,
    ChatSurfaceCurrentUser,
    ChatSurfaceTheme
} from "@mbassist/chat-surface";
import { FirebaseAuthContainer } from "../auth/firebase-auth-container.util";

/**
 * Adapts the main app's existing FirebaseAuthContainer and ThemeContainer
 * into the shape expected by the @mbassist/chat-surface package. Mounted
 * once near the App root.
 */
export function ChatSurfaceWiring({ children }: { children: ReactNode }) {
    const { user } = FirebaseAuthContainer.useContainer();

    const currentUser: ChatSurfaceCurrentUser | null = useMemo(() => {
        if (!user) return null;
        return {
            uid: (user as any).uid ?? (user as any).id ?? "",
            email: user.email ?? "",
            firstName: (user as any).firstName ?? undefined,
            displayName:
                [(user as any).firstName, (user as any).lastName].filter(Boolean).join(" ") ||
                undefined,
            isAnonymous: (user as any).isAnonymous ?? false,
            avatarUrl: (user as any).avatar ?? undefined
        };
    }, [user]);

    const theme: ChatSurfaceTheme = useMemo(
        () => ({
            assistantName: "MBA Analytics"
        }),
        []
    );

    return (
        <ChatSurfaceProvider currentUser={currentUser} theme={theme} mode="main">
            {children}
        </ChatSurfaceProvider>
    );
}
